import { setPageFiles } from '../../shared/getPageFiles';
import { pageFiles } from './pageFiles';
setPageFiles(pageFiles);
